import {SessionContext} from "components/providers/session";
import {useContext} from "react";

export default function formatNumber(value) {
    const session = useContext(SessionContext);
    const languageCode = typeof session.currentLanguage.languageCode !== 'undefined' ? session.currentLanguage.languageCode : session.config.language.languageCode;

    const formatter = new Intl.NumberFormat(languageCode,{
        style: 'decimal',
        minimumFractionDigits: isFraction(value) ? 1 : 0,
        maximumFractionDigits: 2
    });

    function isFraction(number) {
        return number % 1 !== 0;
    }

    return formatter.format(value);
}
